import { format, parseISO } from 'date-fns'
import type { TimePeriod as DailyLinePeriod } from './bookings'

export type DailyLineDay = {
  dayNumber: number
  date: string
  timePeriod?: DailyLinePeriod
  timeLabel?: string | null
  locationName: string | null
}

const DAILY_LINE_PERIOD_LABELS: Record<DailyLinePeriod, string> = {
  am: 'AM',
  midday: 'Midday',
  pm: 'PM',
  'all-day': 'All Day',
  night: 'Night',
}

export function dailyLinePeriodLabel(period: DailyLinePeriod): string {
  return DAILY_LINE_PERIOD_LABELS[period]
}

function shortDateLabel(date: string): string {
  const parsed = parseISO(date)
  return Number.isNaN(parsed.getTime()) ? date : format(parsed, 'MMM d')
}

export function buildDailyLines(days: DailyLineDay[]): string[] | null {
  const lines: string[] = []
  const values = new Set<string>()
  for (const day of days) {
    const value = [
      day.timeLabel || (day.timePeriod ? DAILY_LINE_PERIOD_LABELS[day.timePeriod] : null),
      day.locationName,
    ]
      .filter((part): part is string => Boolean(part))
      .join(' · ')
    if (!value) return null
    values.add(value)
    lines.push(`Day ${day.dayNumber} (${shortDateLabel(day.date)}) · ${value}`)
  }
  return values.size < 2 ? null : lines
}
